import Header from "./header";
import HeaderContent from "./header-content";
import HeaderByline from "./header-byline"; // Header.Content = HeaderContent;
// Header.Byline = HeaderByline;

export default Header;
//# sourceMappingURL=index.js.map